module.exports = __webpack_public_path__ + "static/media/yahoo.2f87e99e.svg";